import { eventQBus } from "@otto-ec/global-resources/event-q-bus";
import { moduleLogger } from "../util";

const log = moduleLogger.scope("bounce");

export class BounceCinema {
	init() {
		log.info("Initialize BounceCinema");
		eventQBus.emit("pattern.carousel.init", ".ft9_benefit_cinema__bounce_cinema > .ft9_benefit_cinema__cinema_module");
	}
}
